import { AlertTriangle, CalendarX, Clock, MailWarning, PhoneOff, Tags } from "lucide-react";
import { Link } from "react-router-dom";

import { dateTime } from "@/components/cockpit/meta";

export const ANOMALY_META = {
  call_untagged: { label: "Appels sans tag", icon: PhoneOff, color: "#e8603c" },
  tag_mismatch: { label: "Tag ≠ statut Ringover", icon: Tags, color: "#db2777" },
  no_next_action: { label: "Sans prochaine action", icon: CalendarX, color: "#ca8a04" },
  unanswered: { label: "Messages sans réponse", icon: MailWarning, color: "#7c3aed" },
  late_action: { label: "Relances en retard", icon: Clock, color: "#dc2626" },
};

export const AnomaliesPanel = ({ data, kind, setKind }) => {
  if (!data) return <p className="ck-muted">Chargement…</p>;
  const items = kind ? data.items.filter((i) => i.kind === kind) : data.items;
  return (
    <div className="ck-anoms" data-testid="ck-anomalies">
      <div className="ck-anom-chips">
        <button type="button" className={!kind ? "on" : ""} onClick={() => setKind("")} data-testid="ck-anom-all"><AlertTriangle size={14} /> Toutes <b>{data.total}</b></button>
        {Object.entries(ANOMALY_META).map(([k, m]) => {
          const Icon = m.icon;
          return <button key={k} type="button" className={kind === k ? "on" : ""} style={{ "--c": m.color }} onClick={() => setKind(k)} data-testid={`ck-anom-${k}`}><Icon size={14} /> {m.label} <b>{data.counts[k] || 0}</b></button>;
        })}
      </div>
      {!items.length ? <p className="ck-empty" data-testid="ck-anom-empty">Aucune anomalie, bravo.</p> : (
        <div className="ck-list">
          {items.map((i) => {
            const m = ANOMALY_META[i.kind];
            const Icon = m.icon;
            return (
              <Link key={`${i.kind}-${i.ref}`} to={`/pipeline?lead=${i.fiche_id}`} className="ck-anom" style={{ "--c": m.color }} data-testid={`ck-anom-item-${i.ref}`}>
                <span className="ck-type"><Icon size={14} /></span>
                <span className="ck-anom-body"><strong>{i.title || `Fiche ${i.fiche_id}`}</strong><span>{i.label}</span></span>
                <span className="ck-muted">{i.user_name || ""}{i.at ? ` · ${i.at.length > 10 ? dateTime(i.at) : i.at}` : ""}</span>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
};
